export const MAIN_FONT = 'Inter'
export const FALLBACK_FONT = 'Metropolis'

export enum FONT_WEIGHT {
  BOLD = 700,
  MEDIUM = 500,
  REGULAR = 400,
}

export enum FONT_SIZE {
  H1 = '24px',
  H1_MOBILE = '24px',
  H2 = '18px',
  H2_MOBILE = '20px',
  H3 = '16px',
  H3_MOBILE = '18px',
  H4 = '14px',
  P1 = '14px',
  P1_MOBILE = '16px',
  SMALL = '12px',
  SMALL_MOBILE = '14px',
}

export enum LINE_HEIGHT {
  H1 = '29px',
  H1_MOBILE = '28px',
  H2 = '22px',
  H2_MOBILE = '23px',
  H3 = '19px',
  H3_MOBILE = '21px',
  H4 = '17px',
  P1 = '17px',
  P1_MOBILE = '19px',
  SMALL = '15px',
  SMALL_MOBILE = '17px',
}
